<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useForwardExpose } from 'reka-ui';
import { Input, type InputVariants } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
    size?: InputVariants['size'];
}>();

const { forwardRef } = useForwardExpose();
</script>

<template>
    <Input
        data-slot="input-group-control"
        :ref="forwardRef"
        :class="
            cn(
                'flex-1 rounded-none border-0 bg-transparent shadow-none focus-visible:ring-0',
                props.class
            )
        "
        v-bind="{ size }"
    />
</template>
